import * as React from "react";
import styled, { css } from "react-emotion";
import { small, strong } from "../theme/typefaces";
import { primaryColors, zuerichBlueColors } from "../theme/colors";
import { Icon } from "../theme/icons";
import { spacing } from "../theme/layout";
const tagStyle = css `
  ${small};
  ${strong};
  display: inline-block;
  text-align: center;
  white-space: nowrap;
  user-select: none;
  border: none;
  border-radius: 3px;
  line-height: 26px;
  height: 26px;
  transition: color ease 0.3s, background-color ease 0.3s;
  color: ${primaryColors.white};
  background-color: ${zuerichBlueColors["800"]};
  ${spacing.pa0};
  ${spacing.ph1};
  cursor: pointer;
  &:hover,
  :focus {
    color: ${primaryColors.white};
    background-color: ${zuerichBlueColors["700"]};
    outline: 0;
  }
`;
const invertedTagStyle = css `
  ${tagStyle};
  color: ${primaryColors.zuerichBlue};
  background-color: ${primaryColors.white};

  &:hover {
    color: ${primaryColors.zuerichBlue};
    background-color: ${zuerichBlueColors["50"]};
  }
`;
const lightTagStyle = css `
  ${tagStyle};
  color: ${primaryColors.zuerichBlue};
  background-color: ${zuerichBlueColors["100"]};

  &:hover {
    color: ${primaryColors.zuerichBlue};
    background-color: ${zuerichBlueColors["200"]};
  }
`;
const Label = styled("span") `
  margin: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 24ch;
  display: inline-block;
  vertical-align: middle;

  svg + &,
  & + svg {
    margin-left: 0.5em;
  }
`;
const iconByType = {
    Dimension: "Tag",
    Topic: "Folder",
    Time: "Time",
    Location: "Location"
};
export const Tag = ({ appearance = "dark", label, tagType, ...buttonProps }) => {
    const tagClassName = appearance === "dark"
        ? tagStyle
        : appearance === "light" ? lightTagStyle : invertedTagStyle;
    return (<button className={tagClassName} title={label} {...buttonProps}>
      {tagType && <Icon name={iconByType[tagType]}/>}
      <Label>{label}</Label>
    </button>);
};
export const RemovableTag = ({ appearance = "dark", label, tagType, ...buttonProps }) => {
    const tagClassName = appearance === "dark"
        ? tagStyle
        : appearance === "light" ? lightTagStyle : invertedTagStyle;
    return (<button className={tagClassName} title={label} {...buttonProps}>
      {tagType && <Icon name={iconByType[tagType]}/>}
      <Label>{label}</Label>
      <Icon name="Cross"/>
    </button>);
};



// WEBPACK FOOTER //
// ./src/components/Tag.tsx